import React from "react";

function RulesRegulation({ rules }) {
  return (
    <div className="flex flex-col gap-4 my-4 ">
      <h1 className="text-xl font-gilroy-semibold">
        {rules?.title?.replaceAll("_", " ")}
      </h1>
      {rules?.response?.length > 0 && (
        <ul className=" flex flex-col gap-2 text-[#707C97]">
          {rules?.response?.map((rule, index) => (
            <li key={rule?.substr(0, 5)}>{`${index + 1}. ${rule}`}</li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default RulesRegulation;
